// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A meal's minutes as the app shows them (device test 2026-10-13): "25 Min aktiv · 45 gesamt" when the
 * hands-on and total minutes differ, else "25 Min". Amy and the server speak in TOTAL minutes, so the
 * app never shows the hands-on figure alone where the two differ. Mirror of mobile/src/lib/mealMinutes.ts.
 */
type T = (key: string, vars?: Record<string, string | number>) => string

export function mealMinutesLabel(activeMinutes: number, totalMinutes: number | null | undefined, t: T): string {
  if (typeof totalMinutes === "number" && totalMinutes > activeMinutes) {
    return t("views.mealCard.minutesActiveTotal", { active: activeMinutes, total: totalMinutes })
  }
  return t("views.mealCard.minutesShort", { minutes: activeMinutes })
}
